module.exports = __webpack_public_path__ + "static/media/Delete.9247f168.svg";